import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Account } from '@app/models/account';
import {Constants} from "@app/constants/constants";
import {UserException} from "@app/models/user-exception";
import {MethodsHelper} from "@app/helpers/methods.helper";
import {UserService} from "@app/services/user.service";
import {NotificationService} from "@app/services/notification.service";
import {BankingDayService} from "@app/services/banking-day.service";
import {PermissionGroupService} from "@app/services/permission-group.service";
import {GlobalErrorHandlerService} from "@app/services/global-error-handler.service";

@Component({
    selector: 'app-exception-popup',
    templateUrl: './exception-popup.component.html',
    styleUrls: ['./exception-popup.component.css'],
    standalone: false
})
export class ExceptionPopupComponent implements OnInit {

    @Input() displayExceptionDialog: boolean;
    @Output() onSubmit = new EventEmitter<Account>();
    @Output() onCancel = new EventEmitter();

    userList = [];
    permissionList = [];
    errorMessage: string | boolean;
    showPagination = false;
    totalElements = 0;
    pageIndex = 0;
    pageSize = Constants.PAGE_ITEM_COUNT;
    selectedUser: any;
    searchingItem = {
        username: undefined,
        firstName: undefined,
        lastName: undefined,
    }
    timerForAutoSearch: any;
    minDate: Date;
    maxDate: Date;

    requestData: UserException;
    yearRange = MethodsHelper.getYearRange(-1);
    submittedForm = false;
    defaultPageParams = {
        size: 10,
        page: 0
    }
    selectedUsers = [];
    selectedRoles = [];

    constructor(
        private userService: UserService,
        private notificationService: NotificationService,
        private bankingDayService: BankingDayService,
        private permissionGroupService: PermissionGroupService,
        private errorService: GlobalErrorHandlerService
    ) { }

    ngOnInit(): void {
        this.getUserList();
        this.getRoleList();
        this.requestData = new UserException();
    }

    getUserList() {
        const pageParams = {
            size: this.pageSize,
            page: this.pageIndex,
            ...this.searchingItem
        };
        const requestData = {
            roleIds: this.selectedRoles.length > 0 ? this.selectedRoles : undefined,
            hasException: false,
            ...this.searchingItem
        }
        this.userService.getListByRoles(pageParams, requestData).subscribe({
            next: (data) => {
                this.userList = data.content;
                this.totalElements = data.totalElements;
                this.showPagination = this.totalElements > Constants.PAGE_ITEM_COUNT;
            },
            error: (err) => {
                this.errorMessage = this.errorService.handleError(err);
                if(this.errorMessage)
                    this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${this.errorMessage}` + "</p></div>",
                        "");}
        });
    }

    getRoleList() {
        const pageParams = {
            size: 100,
            page: 0
        };
        this.permissionGroupService.getList(pageParams).subscribe({
            next: (data) => {
                this.permissionList = data.content;
            },
            error: (err) => {
                this.errorMessage = this.errorService.handleError(err);
                if(this.errorMessage)
                    this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${this.errorMessage}` + "</p></div>",
                        "");}
        });
    }

    pageChangeEvent(event) {
        if (event) {
            this.pageIndex = Math.floor(event.first / event.rows);
            this.pageSize = event.rows;
        }
        this.getUserList();
    }

    cancel(dataChanged) {
        this.onCancel.emit(dataChanged);
    }

    submit(form) {
        this.submittedForm = true;
        if (form.form.invalid || this.requestData.userIds.length === 0) {
            return
        }
        this.bankingDayService.setUserException(this.requestData).subscribe({
            next: (data) => {
                this.cancel(true);
            },
            error: (err) => {
                this.errorMessage = this.errorService.handleError(err);
                if(this.errorMessage)
                    this.notificationService.showError("<div class='row'><p class='col-1 d-flex align-items-center'><i class='fa fa-times-circle'></i></p><p class='col'> " + `${this.errorMessage}` + "</p></div>",
                        "");
            }
        })
        this.onSubmit.emit()
    }

    autoSearchTrigger() {
        clearTimeout(this.timerForAutoSearch);
        this.timerForAutoSearch = setTimeout(() => {
            this.getUserList();
        }, 1000);
    }

    getStartDate() {
        const date = this.requestData.startDate.split('-');
        return this.minDate = new Date(date[1] + '-' + date[0] + '-' + date[2]);
    }

    getEndDate() {
        const date = this.requestData.endDate.split('-');
        return this.maxDate = new Date(date[1] + '-' + date[0] + '-' + date[2]);
    }

    getRolesTooltip(userGroups: any[]): string {
        return userGroups.slice(2).map(role => role.name).join(', ');
    }
}
